/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum ContentCollectionSortingType {
    CURATED_FIRST = 'CURATED_FIRST',
    CURATED_ONLY = 'CURATED_ONLY',
    QUERIED_FIRST = 'QUERIED_FIRST',
    QUERIED_ONLY = 'QUERIED_ONLY',
    FALLBACK_CURATED = 'FALLBACK_CURATED'
}



